import { combineReducers } from "redux"
import { routerReducer } from "react-router-redux"
import homeReducer from "../features/home/redux/reducer"
import commonReducer from "../features/common/redux/reducer"
import authReducer from "../features/auth/redux/reducer"
import lhoExplorerReducer from "../features/lho-explorer/redux/reducer"
import damageCaseReducer from "../features/damage-case/redux/reducer"

// NOTE 1: DO NOT CHANGE the 'reducerMap' name and the declaration pattern.
// This is used for Rekit cmds to register new features, remove features, etc.
// NOTE 2: always use the camel case of the feature folder name as the store branch name
// So that it's easy for others to understand it and Rekit could manage theme.

const reducerMap = {
  router: routerReducer,
  home: homeReducer,
  common: commonReducer,
  auth: authReducer,
  lhoExplorer: lhoExplorerReducer,
  damageCase: damageCaseReducer,
}

export default combineReducers(reducerMap)



// WEBPACK FOOTER //
// ./src/common/rootReducer.js